import { Link, useNavigate } from "react-router-dom";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";

export default function BecomeCreator() {
  const navigate = useNavigate();
  const { currentUser, userProfile } = useAuth();

  const handleBecomeCreator = async () => {
    if (!currentUser) {
      navigate("/welcome?auth=signin");
      return;
    }

    try {
      await updateDoc(doc(db, "users", currentUser.uid), {
        isCreator: true,
        updatedAt: serverTimestamp()
      });
      navigate("/creator-onboarding");
    } catch (error) {
      console.error("Become creator error:", error);
      alert("Could not enable creator mode.");
    }
  };

  // Clicking overlay goes back
  const handleOverlayClick = () => {
    navigate(currentUser ? "/" : "/welcome");
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-card become-creator-card" onClick={(e) => e.stopPropagation()}>

        {/* Background orbs */}
        <div className="auth-orb auth-orb-1" />
        <div className="auth-orb auth-orb-2" />

        {/* Close button */}
        <button
          className="modal-close"
          onClick={handleOverlayClick}
          aria-label="Close"
        >
          ✕
        </button>

        {/* Header */}
        <div className="auth-card-header">
          <div className="auth-badge">🎬 Creator Mode</div>
          <h1>Turn your profile into a creator storefront</h1>
          <p>Unlock moments, drops, support tiers, analytics, and Canadian creator payouts.</p>
        </div>

        {/* Feature grid */}
        <div className="creator-feature-grid">
          <div className="creator-feature-card">
            <div className="creator-feature-icon">👁</div>
            <strong>Limited moments</strong>
            <p>Post content that starts free then becomes supporter-only after the view window ends.</p>
          </div>

          <div className="creator-feature-card">
            <div className="creator-feature-icon">⏱</div>
            <strong>Drop mode</strong>
            <p>Schedule releases, build hype, and create urgency around upcoming content.</p>
          </div>

          <div className="creator-feature-card">
            <div className="creator-feature-icon">💎</div>
            <strong>Support tiers</strong>
            <p>Build premium supporter levels and earn recurring revenue from your audience.</p>
          </div>

          <div className="creator-feature-card">
            <div className="creator-feature-icon">🏆</div>
            <strong>User perks</strong>
            <p>Reward supporters with badges, early access, and exclusive perk unlocks.</p>
          </div>

          <div className="creator-feature-card">
            <div className="creator-feature-icon">📊</div>
            <strong>Analytics</strong>
            <p>Track views, earnings, supporters, and engagement from one clean dashboard.</p>
          </div>

          <div className="creator-feature-card">
            <div className="creator-feature-icon">🇨🇦</div>
            <strong>Canadian payouts</strong>
            <p>Finally get paid in CAD with fair 10% founding fees — no surprises.</p>
          </div>
        </div>

        {/* Founding badge */}
        <div className="signup-founding-badge" style={{ marginTop: "8px" }}>
          <span>🌟</span>
          <div>
            <strong>Founding creator rate — 10% fees forever</strong>
            <p>Lock in the lowest rate before beta ends. Goes to 15% after launch.</p>
          </div>
        </div>

        {/* CTA */}
        <div className="become-creator-actions">
          <button
            type="button"
            className="auth-submit"
            onClick={handleBecomeCreator}
          >
            {userProfile?.isCreator ? "Continue setup" : "Start creator setup"}
          </button>

          <Link
            to="/discover"
            className="become-creator-explore"
          >
            Explore creators first
          </Link>
        </div>
      </div>
    </div>
  );
}
